import CustomZObject from './CustomZObject.js';
import {freezePadByPatterns} from "track/freeze/freezePadByPatterns.js"

export default class PadWrapper extends CustomZObject {
    constructor(zobject) {
        super(zobject);

        zobject.setAttribute("secondary-color", "#cdcdcd");
        zobject.setAttribute("primary-color", "#b4b4b4");
        zobject.newAttribute("slot-color");
        zobject.newAttribute("slot-opacity");
        zobject.newAttribute("Pads Per Row", 3);
        zobject.newAttribute("Number of Pads", 9, (x) => {
            if (this.pad) {
                this.pad.onChangePadsCount(x);
            }
        });
        zobject.newAttribute("Show Track Names", true);
        zobject.newAction("Clear Pattern", () => this.clearPattern());
        zobject.newAction("Freeze Pads", () => this.freezePads());
    }

    clearPattern() {
        this.pad.slotTracks.forEach(({pattern}) => pattern.clear());
        this.sequencerEngine.updateTracks();
    }

    isDeletable() {
        return this.pad && this.pad.slots.filter(x => x).length === 0;
    }

    dispose() {
        this.subSequence.deletePad(this.pad);
    }

    freezePads() {
        freezePadByPatterns(this.pad);
    }

    linkPad(pad) {
        if (!pad) {
            return;
        }
        this.pad = pad;
        this.pad.zObject = this.zObject;

        this.pad.onSizeChange(
            this.zObject.width, this.zObject.height);
    }

    getJson(isPreset) {
        let json = super.getJson(isPreset);

        let pad = undefined;
        let fx = undefined;
        if (isPreset) {
            // need to save the actual pad as a preset
            let _pad = this.pad.getJsonForPack();
            pad = [];
            for (let i=0; i < _pad.length; i++) {
                pad.push(_pad[i]);
            }
            fx = _pad.fx;
        }

        let x = {
            ... json,
            padId: this.pad.id,
            pad,
            fx
        };
        return x;
    }

    fromJson(json, x) {
        super.fromJson(json, x);
        let padId = json.padId;

        let subSequence = this.subSequence.getRootSubSequence ?
            this.subSequence.getRootSubSequence() : this.subSequence;

        if (json.pad) {
            // then we need to load the pack
            subSequence.loadPackAsPads(json.pad, json.fx, this.pad).then(
                pad => this.linkPad(pad));
        } else {
            this.linkPad(subSequence.pads.find(x => x.id === padId));
        }
    }
}
